import { Controller } from "@hotwired/stimulus"

// Country/language chips arrive later via Turbo Stream broadcasts from the
// discover-locales job, so the save button's enabled state and label are
// kept in sync via target-connected lifecycle callbacks (fired whenever a
// checkbox target enters/leaves the DOM, including via a stream replace) --
// not a one-time connect() check.
export default class extends Controller {
  static targets = [ "submit", "label", "checkbox" ]
  static values = { platform: String }

  checkboxTargetConnected() {
    this.refresh()
  }

  checkboxTargetDisconnected() {
    this.refresh()
  }

  selectAll(event) {
    event.preventDefault()
    this.checkboxTargets.forEach((checkbox) => {
      if (!checkbox.disabled) checkbox.checked = true
    })
    this.refresh()
  }

  deselectAll(event) {
    event.preventDefault()
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = false })
    this.refresh()
  }

  refresh() {
    const checked = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
    this.submitTarget.disabled = checked === 0
    if (this.hasLabelTarget) {
      const unit = this.platformValue === "android" ? "language" : "country"
      const unitPlural = this.platformValue === "android" ? "languages" : "countries"
      this.labelTarget.textContent = `Watch ${checked} ${checked === 1 ? unit : unitPlural}`
    }
  }
}
